// Port of SuiteModel/ProseWords.swift: words for analysis (frequency, readability, dialogue share, overused words):
// runs of letters, with apostrophes inside a word (don't, O’Brien); numbers aren't words here. The writer-facing word
// count (`wordCount` in proseMarkdown.ts) counts as Scrivener does instead.

/** `ProseWords.pattern`. */
export const PROSE_WORD = /\p{L}+(?:['’]\p{L}+)*/gu;

/** `ProseWords.ranges(in:)`: the UTF-16 [start, end) ranges of the words in `text`. */
export function proseWordRanges(text: string): [number, number][] {
  const out: [number, number][] = [];
  for (const m of text.matchAll(PROSE_WORD)) out.push([m.index!, m.index! + m[0].length]);
  return out;
}

/** The words themselves. */
export function proseWords(text: string): string[] {
  return text.match(PROSE_WORD) ?? [];
}
